<template>
  <div class="table-container">
    <div class="h1">{{t('enum.text_17')}}</div>
    <div class="sr-container__content sr-container__content--row">
      <el-form :model="formReq.fields" inline :label-width="localCN?'120px':'170px'" label-position="left">
        <el-form-item :label="formReq.schema.acctId.label">
          <el-input v-model="formReq.fields.acctId" :placeholder="formReq.schema.acctId.placeholder" />
        </el-form-item>
        <el-form-item :label="formReq.schema.inviteCode.label">
          <el-input v-model="formReq.fields.inviteCode" :placeholder="formReq.schema.inviteCode.placeholder" />
        </el-form-item>
        <!-- <el-form-item :label="formReq.schema.registerType.label">
          <el-select v-model="formReq.fields.registerType" clearable :placeholder="formReq.schema.registerType.placeholder">
            <el-option :label="t('client.registerType.text_1')" value="1" />
            <el-option :label="t('client.registerType.text_2')" value="2" />
          </el-select>
        </el-form-item> -->
        <el-form-item :label="formReq.schema.stepComplete.label">
          <el-select v-model="formReq.fields.stepComplete" clearable :placeholder="formReq.schema.stepComplete.placeholder">
            <el-option :label="t('client.stepComplete.text_0')" :value="false" />
            <el-option :label="t('client.stepComplete.text_1')" :value="true" />
          </el-select>
        </el-form-item>
        <el-form-item :label="formReq.schema.registerDate.label">
          <el-date-picker
              v-model="formReq.fields.registerDate"
              type="daterange"
              unlink-panels
              range-separator="-"
              value-format="YYYY-MM-DD"
              :start-placeholder="t('components.datepicker.start')"
              :end-placeholder="t('components.datepicker.end')">
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="formReq.schema.submitDate.label">
          <el-date-picker
              v-model="formReq.fields.submitDate"
              type="daterange"
              unlink-panels
              range-separator="-"
              value-format="YYYY-MM-DD"
              :start-placeholder="t('components.datepicker.start')"
              :end-placeholder="t('components.datepicker.end')">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="fetchData">{{t('client.content.text_1')}}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table row-class-name="row-con" :data="tbl.data.list" v-loading="tbl.data.loading">
      <sr-tbl-column :columns="tbl.columns">
        <template #acctId="scope">
          <div>
            <div>{{scope.row.customerName}}</div>
            <div>{{scope.row.acctId}}</div>
          </div>
        </template>
        <template #registerCountry="scope">
          <div v-if="scope.row.registerCountry">
            <div>{{clientCountryCode[scope.row.registerCountry] || '-'}}</div>
          </div>
          <div v-else>-</div>
        </template>
        <template #registerType="scope">
          <div class="header-cell">
            <span v-if="scope.row.registerType">{{registerTypeEnum[scope.row.registerType]}}</span>
            <span v-else>-</span>
          </div>
        </template>
        <template #status="scope">
          <div class="header-cell">
            <el-tag v-if="scope.row.status || scope.row.status === 0" :type="registerStatTag[scope.row.status]">
              {{registerStatusEnum[scope.row.status]}}
            </el-tag>
            <span v-else>-</span>
          </div>
        </template>
        <template #stepComplete="scope">
          <div class="header-cell">
            <el-tag :type="stepCompleteTag[scope.row.stepComplete]">
              {{stepCompleteEnum[scope.row.stepComplete]}}
            </el-tag>
          </div>
        </template>
        <template #inviteRemark="{ row }">
          <el-tooltip :content="row.inviteRemark" placement="top" :disabled="!row.inviteRemark" popper-class="remark-tooltip">
            <div class="remark-text">{{ row.inviteRemark || '-' }}</div>
          </el-tooltip>
        </template>
      </sr-tbl-column>
      <template #empty>
        <div class="empty-wrap">
          <img :src="emptyImg" alt="">
          {{t('client.content.text_2')}}
        </div>
      </template>
    </el-table>
    <sr-tbl-pagination
        v-model:current-page="tbl.pagination.currentPage"
        v-model:page-size="tbl.pagination.pageSize"
        :total="tbl.pagination.total"
        @fetchData="fetchData">
    </sr-tbl-pagination>
  </div>
</template>
<script>
import { useStore } from "vuex";
import tableComp from '@/compositions/modules/table'
import SrTblColumn from '@/components/SrTblColumn'
import { components } from '@libs/ui'
import { ref, reactive } from 'vue'
import { fetchRegisteringList } from "@/api/modules/list"
import formComp from "@/compositions/modules/form"
import { NoUseClientReq } from "@/domain/modules/list"
import { useI18n } from "@/plugins/i18n"
import { dataUtils } from "@libs/utils"

export default {
  components: { SrTblColumn, SrTblPagination: components.SrTblPagination },
  setup() {
    const { t } = useI18n()
    const { tbl, fetchData, formReq, registerTypeEnum, registerStatusEnum, stepCompleteEnum, stepCompleteTag, registerStatTag, ecCountryCode, clientCountryCode } = initTable()
    const emptyImg = ref(require('@/assets/img/dashboard/empty.png'))
    return { tbl, fetchData, emptyImg, formReq, t, registerTypeEnum, registerStatusEnum, stepCompleteEnum, stepCompleteTag, registerStatTag, ecCountryCode, clientCountryCode }  
  }
}

const initTable = () => {
  const { t } = useI18n()
  const { createTable } = tableComp()
  const store = useStore()
  const { formReq } = initForm()
  const { ecCountryCode, clientCountryCode } = store.state.base.dict
  const registerTypeEnum = {
    1: t('client.registerType.text_1'),
    2: t('client.registerType.text_2'),
  }
  const registerStatusEnum = {
    0: t('client.registerStatus.text_0'),
    1: t('client.registerStatus.text_1'),
    2: t('client.registerStatus.text_2'),
    3: t('client.registerStatus.text_3'),
    4: t('client.registerStatus.text_4'),
    5: t('client.registerStatus.text_5'),
    6: t('client.registerStatus.text_6'),
    // 8: t('client.registerStatus.text_8'),
    R: t('client.registerStatus.text_R'),
  }
  const stepCompleteEnum = {
    false: t('client.stepComplete.text_0'),
    true: t('client.stepComplete.text_1'),
  }
  const stepCompleteTag = {
    false: 'warning',
    true: 'success',
  }
  const registerStatTag = {
    0: 'primary',
    1: 'success',
    2: 'danger',
    3: 'success',
    4: 'danger',
    5: 'warning',
    6: 'info',
    R: 'danger',
  }
  const columnsTemp = [
    // { prop: 'customerName', align: "left", label: t('client.table.text_1') },
    { slot: 'acctId', align: "left", label: t('client.table.text_1') },
    { slot: 'registerType', align: "center", label: t('client.registerType.label') },
    { slot: 'registerCountry', align: "left", label: t('client.accountTable.text_3') },
    { prop: 'inviteCode', align: "left", label: t('dashboard.table.text_7') },
    { slot: 'inviteRemark', align: "left", label: t('salesSettlement.table.text_3'), tooltip: 'off' },
    { slot: 'status', align: "center", label: t('client.accountTable.text_12') },
    { slot: 'stepComplete', align: "center", label: t('client.accountTable.text_13') },
    { prop: 'submitTime', align: "center", label: t('client.accountTable.text_14'), width: '180px' },
    { prop: 'sysTxnDate', align: "center", label: t('client.form.text_7'), width: '180px' },
  ]
  const tbl = createTable({ columns: columnsTemp })
  const fetchData = async () => {
    const params = {
      pageInfo: {
        current: tbl.pagination.currentPage,
        size: tbl.pagination.pageSize
      },
      acctId: formReq.fields.acctId.trim(),
      inviteCode: formReq.fields.inviteCode.trim(),
      registerType: formReq.fields.registerType,
      stepComplete: formReq.fields.stepComplete,
      registerDate: formReq.fields.registerDate,
      submitDate: formReq.fields.submitDate,
    }
    tbl.data.loading = true
    tbl.data.list = []
    try {
      const res = await fetchRegisteringList(params)
      tbl.data.list = (res.list || []).map(item => ({
        ...item,
        submitTime: dataUtils.formatDate(item.submitTime, 'YYYY-MM-DD'),
      }))
      tbl.pagination.total = res.pageInfo?.total || 0
    } finally {
      tbl.data.loading = false
    }
  }
  fetchData()
  return { tbl, fetchData, formReq, registerTypeEnum, registerStatusEnum, stepCompleteEnum, stepCompleteTag, registerStatTag, ecCountryCode, clientCountryCode }  
}

// 初始化form
const initForm = () => {
  const { createForm } = formComp()
  const formReq = reactive({ ...createForm({ items: NoUseClientReq }) })
  return { formReq }
}
</script>



<style lang="scss" scoped rel="stylesheet/scss">
  .table-container {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background-color: #fff;
    border-radius: 4px;
    padding: 30px 20px;

    .empty-wrap {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 160px auto;
      box-sizing: border-box;

      & > img {
        width: 190px;
        height: auto;
        display: block;
        margin-bottom: 38px;
      }
    }

    /deep/ .el-form .el-input__inner {
      width: 220px;
    }

    /deep/ .el-date-editor {
      width: 100%;
    }

    :deep(.row-con) {
      height: 57px;
    }

    .remark-text {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
</style>
<style>
  .remark-tooltip {
    max-width: 500px;
    white-space: normal;
    word-break: break-all;
  }
</style>
